import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'lms-configs',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const lmsConfig = require('./LMSDropdownConfig').default
        cb(null, lmsConfig)
      }, 'LMSDropdownConfig')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/LMSDropdownConfig/index.js